export default {
	search_title: 'Nápověda k vyhledávání v Digitálním archivu',
	search_text_prefix:
		'Aplikace umožňuje na základě zadaných kritérií vyhledávat informace o osobách a domech v ',
	search_text_bold: 'Digitálním archivu města Brna',
	search_text_suffix:
		'. Vyhledávání je možné pomocí dvou úrovní, které umožňují uživateli prohledávat informace uložené v tomto digitálním archivu.',
	basic_search_title: 'Základní vyhledávání',
	basic_search_text: 'Umožňuje vyhledávat na základě následujících metadat:',
	metadata: {
		year: 'Ročník sčítání',
		street: 'Název ulice',
		house: 'Číslo domu',
		surname: 'Příjmení',
		firstname: 'Jméno',
	},
	search_in_connected_municipalities_title: 'Vyhledávání v připojených obcích',
	search_in_connected_municipalities_prefix:
		'V případě vyhledávání v obcích připojených k Brnu až v roce 1919 je nutné zadat do vyhledávače v rubrice ',
	search_in_connected_municipalities_bold: 'Název ulice',
	search_in_connected_municipalities_suffix:
		' český název obce. Příslušné ulice se po napsání českého názvu obce (například Královo Pole, Husovice atd.) objeví v nabídce za pomlčkou. Protože v rámci těchto obcí nebyly k dispozici rejstříky, není možné vyhledávat v nich podle jmen a příjmení.',
	advanced_search_title: 'Pokročilé vyhledávání',
	advanced_search_text:
		'Systém pokročilého vyhledávání je určený pro archiváře a badatele.',
	advanced_search_criteria: {
		text: 'Dostupná jsou následující kritéria:',
		volume: 'Svazek - označení jednotlivého svazku jmenného rejstříku',
		page_number:
			'Číslo strany - číslo strany v knize, kde se vyskytuje hledané jméno',
		inventory_number:
			'Inventární číslo - unikátní záznam pro každou knihu jak ze jmenných rejstříků, tak z operátů',
	},
	search_results_title: 'Výsledky vyhledávání',
	search_results_text:
		'V přehledné tabulce jsou zobrazeny záznamy, které vyhovují zadaným kritériím vyhledávání. V každém řádku tabulky podle konkrétních požadavků je postupně uveden rok sčítání, název ulice, číslo domu, obraz operátů, příjmení, jméno, stránka jmenného rejstříku. Pro zobrazení konkrétního digitalizovaného záznamu archiválie je třeba kliknout na lupu.',
	archive_view_title: 'Zobrazení archiválie',
	archive_view_text:
		'V záhlaví zobrazené archiválie se nacházejí údaje o aktuální vybrané osobě v horizontálním menu. Součástí menu prohlížeče jsou funkce na jeho zvětšení/zmenšení, náhled archiválie, rotaci o 90 stupňů, návrat na předcházející obrazovku a listování ve stránkách jednotlivé archiválie.',
};
